import { Injectable } from "@angular/core";
import { GlobalProvider } from "src/services/global";
import { Pages } from "./interfaces/pages";

@Injectable({
  providedIn: "root",
})
export class MenuHelper {
  map = [];
  public generalPages: Array<Pages> = [];
  public storePages: Array<Pages> = [];
  public essentialPages: Array<Pages> = [];
  public customerPages: Array<Pages> = [];
  public empPages: Array<Pages> = [];
  constructor(private g: GlobalProvider) {
    this.map[`/accessRole`] = `AccessRole`;
    this.map[`/user`] = `User`;
    this.map[`/customer`] = `Customer`;
    this.map[`/voucher`] = `Voucher`;
    this.map[`/category`] = `Category`;
    this.map[`/menuItem`] = `Menu Item`;
    this.map[`/checkout`] = `Checkout`;
  }
  clearPages() {
    this.generalPages = [];
    this.storePages = [];
    this.essentialPages = [];
    this.customerPages = [];
    this.empPages = [];
  }
  loadAdminMap() {
    this.clearPages();
    this.addAdminRoute(
      {
        title: "Dashboard",
        url: "/dashboard",
        direct: "root",
        icon: "grid",
      },
      this.generalPages,
      [`OUTLET ADMIN`, `OPERATOR`, `MARKETING`]
    );
    // this.addAdminRoute(
    //   {
    //     title: "Happening",
    //     url: "/happening",
    //     direct: "root",
    //     icon: "megaphone",
    //   },
    //   this.generalPages,
    //   [`MARKETING`]
    // );
    // this.addAdminRoute(
    //   {
    //     title: "FAQ",
    //     url: "/faq",
    //     direct: "root",
    //     icon: "help-circle",
    //   },
    //   this.generalPages,
    //   [`MARKETING`]
    // );
    this.addAdminRoute(
      {
        title: "Outlet",
        url: "/outlet",
        direct: "root",
        icon: "business",
      },
      this.generalPages,
      [`OPERATOR`, `OUTLET ADMIN`]
    );
    this.addAdminRoute(
      {
        title: "Tenant",
        url: "/tenant",
        direct: "root",
        icon: "person",
      },
      this.generalPages,
      [`OPERATOR`, `OUTLET ADMIN`]
    );
    this.addAdminRoute(
      {
        title: "ENT",
        url: "/ent",
        direct: "root",
        icon: "settings",
      },
      this.generalPages,
      [`OPERATOR`, `OUTLET ADMIN`]
    );
    // this.addAdminRoute(
    //   {
    //     title: "General Sales",
    //     url: "/sales",
    //     direct: "root",
    //     icon: "stats-chart",
    //   },
    //   this.generalPages,
    //   [`OPERATOR`, `MARKETING`]
    // );
    this.addAdminRoute(
      {
        title: "Portion",
        url: "/portion",
        direct: "root",
        icon: "extension-puzzle",
      },
      this.generalPages,
      [`OPERATOR`]
    );
    this.addAdminRoute(
      {
        title: "Item",
        url: "/item",
        direct: "root",
        icon: "basket",
      },
      this.generalPages,
      [`OPERATOR`, `OUTLET ADMIN`]
    );
    this.addAdminRoute(
      {
        title: "Item Pricing",
        url: "/itemPricing",
        direct: "root",
        icon: "pricetag",
      },
      this.generalPages,
      [`OPERATOR`]
    );

    // this.addAdminRoute(
    //   {
    //     title: "Customer",
    //     url: "/customer",
    //     direct: "root",
    //     icon: "people",
    //   },
    //   this.generalPages,
    //   [`OPERATOR`, `MARKETING`, `OUTLET ADMIN`]
    // );

    // this.addAdminRoute(
    //   {
    //     title: "Customer Voucher",
    //     url: "/customerVoucher",
    //     direct: "root",
    //     icon: "gift",
    //   },
    //   this.generalPages,
    //   [`SUPER FINANCE`, `MARKETING`, `ADMIN`]
    // );

    this.addAdminRoute(
      {
        title: "Transaction",
        url: "/transaction",
        direct: "root",
        icon: "cash",
      },
      this.generalPages,
      [`OPERATOR`]
    );
    // this.addAdminRoute(
    //   {
    //     title: "Top Up",
    //     url: "/topup",
    //     direct: "root",
    //     icon: "wallet",
    //   },
    //   this.generalPages,
    //   [`OPERATOR`]
    // );
    // this.addAdminRoute(
    //   {
    //     title: "Withdrawal",
    //     url: "/withdrawal",
    //     direct: "root",
    //     icon: "wallet",
    //   },
    //   this.generalPages,
    //   [`OPERATOR`]
    // );
    // this.addAdminRoute(
    //   {
    //     title: "Account Removal",
    //     url: "/accountRemoval",
    //     direct: "root",
    //     icon: "person-remove",
    //   },
    //   this.generalPages,
    //   [`OPERATOR`]
    // );
    // this.addAdminRoute(
    //   {
    //     title: "Credit Adjustment",
    //     url: "/creditAdjustment",
    //     direct: "root",
    //     icon: "square",
    //   },
    //   this.generalPages,
    //   [`SUPER FINANCE`]
    // );
    // this.addAdminRoute(
    //   {
    //     title: "Notification",
    //     url: "/notification",
    //     direct: "root",
    //     icon: "notifications",
    //   },
    //   this.generalPages,
    //   [`OUTLET ADMIN`, `OPERATOR`, `MARKETING`]
    // );
    this.addAdminRoute(
      {
        title: "Report",
        url: "/report",
        direct: "root",
        icon: "clipboard",
      },
      this.generalPages
    );
    // this.addAdminRoute(
    //   {
    //     title: 'Company Profile',
    //     url: '/companyProfile',
    //     direct: 'root',
    //     icon: 'cog',
    //   },
    //   this.generalPages
    // );
    this.addAdminRoute(
      {
        title: "Staff",
        url: "/user",
        direct: "root",
        icon: "person",
      },
      this.generalPages,
      [`ADMIN`]
    );
    this.addAdminRoute(
      {
        title: "Tenant User",
        url: "/tenantUser",
        direct: "root",
        icon: "person",
      },
      this.generalPages,
      [`OUTLET ADMIN`, `OPERATOR`]
    );
    this.addAdminRoute(
      {
        title: "Setting",
        url: "/setting/1/detail",
        direct: "root",
        icon: "settings",
      },
      this.generalPages,
      [`OPERATOR`]
    );
    // this.addAdminRoute(
    //   {
    //     title: 'System',
    //     url: '/system',
    //     direct: 'root',
    //     icon: 'person',
    //   },
    //   this.generalPages
    // );

    this.generalAccessCheck();
  }
  generalAccessCheck() {
    return;
    if (
      `ADMIN` === this.g.role ||
      (this.g.accessRole && this.g.accessRole.all)
    ) {
      this.g.auditLogAllow = true;
      this.g.docShareAllow = true;
    } else {
      const auditLog = this.g.accessRole.accessRoleRights.find(
        (r) => r.accessClassName === `AuditLog`
      );
      if (auditLog) {
        this.g.auditLogAllow = true;
      }

      const docShare = this.g.accessRole.accessRoleRights.find(
        (r) => r.accessClassName === `DocShare`
      );
      if (docShare) {
        this.g.docShareAllow = true;
      }
    }
  }
  addAdminRoute(obj, routes, rolesCheck = null) {
    if (
      !rolesCheck ||
      ((this.g.role === "ADMIN" || this.g.role === "SUPER FINANCE") &&
        !rolesCheck.includes(`SUPER FINANCE`))
    ) {
      routes.push(obj);
      return;
    } else {
      if (rolesCheck.includes(this.g.role)) {
        routes.push(obj);
        return;
      }
    }
  }

  loadMap() {
    this.clearPages();
    this.addRoute(
      {
        title: "My Workshift",
        url: "/emp/workshift",
        direct: "root",
        icon: "flash",
      },
      this.empPages
    );
  }
  addRoute(obj, routes) {
    routes.push(obj);
  }
}
